/**
 * Application Constants
 * Contains configuration for AppSync, IVS, Cognito, and UI styling
 */

// Cognito Configuration
export const COGNITO_CONFIG = {
  userPoolId: 'us-west-2_ue3kaLI6p',
  userPoolClientId: '5jijmrh9kgsrdgtk4lhc8em0vr'
};

// API Gateway Configuration
export const API_CONFIG = {
  endpoint: 'https://fq07z7b259.execute-api.us-west-2.amazonaws.com/prod'
};

// AppSync Event API Configuration
export const APPSYNC_CONFIG = {
  apiKey: 'da2-yov4tgaghbhtllalqrf5c4ey4y',
  httpEndpoint: 'https://iiyygik5jrfmhknljy5sxtgzra.appsync-api.us-west-2.amazonaws.com',
  realtimeEndpoint: 'iiyygik5jrfmhknljy5sxtgzra.appsync-realtime-api.us-west-2.amazonaws.com',
  channelName: '/default/twota5lemvg7pcy5nibdiqnqim'
};

// GameLift Streams Configuration
export const GAMELIFT_STREAMS_CONFIG = {
  gameLibrary: {
    'IVS Slots': {
      applicationId: 'a-RPK5hHWbj',
      streamGroupId: 'sg-WmBDxS6a3',
      supportsDirectBroadcast: true,
      supportsCouchCoop: false,
    },
  },
  defaultRegion: 'us-west-2',
};

// IVS WHIP Endpoint for direct broadcast
export const IVS_WHIP_ENDPOINT = 'https://global.whip.live-video.net';

// Feature Flags
export const ENABLE_GAMELIFT_IVS_DIRECT_BROADCAST = true; // Set to true when ready

// IVS Stage Configuration
export const IVS_CONFIG = {
  stageArn: 'arn:aws:ivs:us-west-2:639934345351:stage/X6um1tv9DICJ',
};

// Color Scheme
export const COLORS = {
  primaryBackground: '#2a1f3d',
  secondaryBackground: '#3d2f52',
  accentColor: '#ff6b9d',
  successColor: '#4ecdc4',
  textPrimary: '#ffffff',
  textSecondary: '#b8a9d1',
  borderColor: '#5a4a6f'
};

// Stream Source Attributes
export const STREAM_SOURCE = {
  GAMEPLAY: 'gameplay',
  PLAYER_WEBCAM: 'player_webcam'
} as const;

// User Roles
export const USER_ROLES = {
  PLAYER: 'player',
  VIEWER: 'viewer'
} as const;

// User Email Configuration
export const USER_EMAILS = {
  PLAYER: 'player@ivs.rocks',
  VIEWER: 'viewer@ivs.rocks'
} as const;
